export const environment = {
    production: false,
    // apiSocket: 'https://www.ecuataxiapp.com/conexion-taxi'
    // apiBackend: 'https://www.ecuataxiapp.com/api', 
    apiSocket: 'https://www.desarrollo.ecuataxiapp.com/conexion-taxi',
    apiBackend: 'https://www.desarrollo.ecuataxiapp.com/api'
};
